import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  runTour: localStorage.getItem("hasSeenTour") === 'false' || localStorage.getItem("hasSeenTour") === null ? true : false,
  steps: {
    "/dashboard": [
      {
        content: "Welcome to your dashboard!",
        target: ".mues_dashboard",
        placement: "center",
        disableBeacon: true,
      },
      {
        content: "Welcome to the Activity Section",
        target: ".activity_planned_and_executed",
        disableBeacon: true,
      },
      {
        content:
          "Welcome to the Leaderboard, where principal can see teacher's progress",
        target: ".leaderboard_section",
        placement: "top",
        disableBeacon: true,
      },
      {
        content:
          "Welcome to the Fees Section, where principal can see fees status",
        target: ".fees_section",
        placement: "top",
        disableBeacon: true,
      },
      {
        content: "In this graph you can see the inventory expense",
        target: ".inventory_section",
        placement: "top",
        disableBeacon: true,
      },
      {
        content:
          "In this graph you can see the consumption of the inventory",
        target: ".consumption_section",
        disableBeacon: true,
        placement: "top",
      },
      {
        content: "In this graph you can see the fees information",
        target: ".feetimeframe_section",
        placement: "top",
        disableBeacon: true,
      },
      {
        content: "In this graph you can see the fees recovery health",
        target: ".fees_recovery_section",
        placement: "top",
        disableBeacon: true,
      },
      {
        content: "This is our teachers and students attendance report",
        target: ".attendance_section",
        placement: "left",
        disableBeacon: true,
      },
      {
        content:"In this section you can see the recent activity performed by classes",
        target: ".recent_activity_section",
        placement: "left",
        disableBeacon: true,
      },
      {
        content: "In this section you can watch daily reports",
        target: ".daily_report_section",
        placement: "left",
        disableBeacon: true,
      },
    ],
    "/dashboard/team/teacher": [
      {
        target: ".team_container",
        content: "Welcome to the Team Section!",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_navigation_container",
        content:
          "This is our team navigation section where you can see your teacher's list and add new ones",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: ".team_navigation_button",
        content: "Add new teacher member from this button",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: ".team_container",
        content: "Let's create a new teacher member",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_container",
        content: "You have successfully added a new team member",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_members_section",
        content: "Here you can see the list of your team members",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: ".teacher_profile_section",
        content:
          "This this your team member information and other functionality",
        disableBeacon: true,
        placement: "bottom",
      },
      {
        target: ".team_profile_icon_section",
        content:
          "This is the function button that will like edit profile, delete profile and more",
        disableBeacon: true,
        placement: "bottom",
      },
      {
        target: ".teacher_review_section",
        content: "This this your team member reviews by parents",
        disableBeacon: true,
        placement: "bottom",
      },
      {
        target: ".analytic_section",
        content: "This this your analytic_section",
        disableBeacon: true,
      },
    ],
    "/dashboard/team/admin": [
      {
        target: ".team_container",
        content: `Welcome to the Admin Section! It's features and functions work exactly the same as the teacher section`,
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_navigation_container",
        content:
          "This is our team navigation section where you can see your admin's list and add new ones",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: ".team_navigation_button",
        content: "Add new team member from this button",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: ".team_container",
        content: "Let's create a new admin member",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_container",
        content: "You have successfully added a new admin",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_members_section",
        content: "Here you can see the list of your admin",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: "#admin_profile_section",
        content:
          "This this your team member information and other functionality",
        disableBeacon: true,
        placement: "bottom",
      },
      {
        target: ".team_profile_icon_section",
        content:
          "This is the function button that will like edit profile, delete profile and more",
        disableBeacon: true,
        placement: "bottom",
      },
      {
        target: ".admin_review_section",
        content: "This this your team member reviews by parents",
        disableBeacon: true,
        placement: "bottom",
      },
    ],
    "/dashboard/team/helping-staff": [
      {
        target: ".team_container",
        content: `Welcome to the Helping Staff Section! It's features and functions work exactly the same as the teacher and admin section`,
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_navigation_container",
        content:
          "This is our team navigation section where you can see your helping staff list and add new ones",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: ".team_navigation_button",
        content: "Add new team member from this button",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: ".team_container",
        content: "Let's create a new helping staff member",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_container",
        content: "You have successfully added a new helping staff",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".team_members_section",
        content: "Here you can see the list of your helping staff",
        disableBeacon: true,
        placement: "right",
      },
      {
        target: "#helpingStaff_profile_section",
        content:
          "This this your team member information and other functionality",
        disableBeacon: true,
        placement: "bottom",
      },
      {
        target: ".team_profile_icon_section",
        content:
          "This is the function button that will like edit profile, delete profile and more",
        disableBeacon: true,
        placement: "bottom",
      },
      {
        target: ".helping_staff_review_section",
        content: "This this your team member reviews by parents",
        disableBeacon: true,
        placement: "bottom",
      },
    ],
    "/dashboard/team/leader-board": [
      {
        target: ".leader_board",
        content: "Welcome to Leader board!",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".leader_board_card",
        content:
          "In this Section you will get a summery of teacher and there points and rating",
      },
      {
        target: ".spotlight_section",
        content: "This is the Spotlight Section",
      },
      {
        target: ".teacher_training_section",
        content:
          "Here we are going to provide the training sessions for teacher's",
      },
    ],
    "/dashboard/classes/add-new-class": [
      {
        target: ".active_navigation_card",
        content:
          "Welcome to Class section. Here you are going to handle all your classes information and functions related to class",
        disableBeacon: true,
      },
      {
        target: ".add_class_section",
        content: "With the help of this button you can add a new class",
        disableBeacon: true,
      },
      {
        target: ".mues_dashboard",
        content: "So let's create a new class now",
        disableBeacon: true,
        placement: "center",
      },
      {
        target: ".mues_dashboard",
        content: "So let's create a new class now",
        disableBeacon: true,
        placement: "center",
      }
    ],
    "/dashboard/inventory/add-vendors":[
      {
        target: ".mues_dashboard",
        content:"Welcome to Inventory - Vendors section.",
        disableBeacon: true,
        placement: "center"
      },{
        target: ".mues_dashboard",
        content:"Here you are going to handle all your inventory vendors. To start the inventory you need to add a vendor first",
        disableBeacon: true,
        placement: "center"
      },
      {
        target: ".large_btn",
        content:"So let's create a vendor first",
        disableBeacon: true
      },{
        target: ".pass",
        content:"",
        disableBeacon: true
      },{
        target: ".mues_dashboard",
        content:"You have successfully a new vendor",
        disableBeacon: true,
        placement: "center"
      }
    ],
    "/dashboard/inventory/Inventory":[
      {
        target: ".mues_dashboard",
        content:"Welcome to Inventory section.",
        disableBeacon: true,
        placement: "center"
      },
      {
        target: ".store_container",
        content:"This is your store inventory's. Here you can add inventory for your school. By clicking any of the item",
        disableBeacon: true,
      },
      {
        target: ".pass",
        content:"This is your store inventory's. Here you can add inventory for your school. By clicking any of the item",
        disableBeacon: true,
      },
      {
        target: ".mues_dashboard",
        content:"You have successfully added a new inventory",
        disableBeacon: true,
        placement: "center"
      }
    ],
    "/dashboard/inventory/inventory-overview":[
      {
        target: ".mues_dashboard",
        content:"Welcome to Inventory - Overview section.",
        disableBeacon: true,
        placement: "center"
      },
      {
        target: ".store_list",
        content:"This is you inventory that you just have created.",
        disableBeacon: true,
      },
      {
        target: ".large_store_filter_container",
        content:"Here you can filter you your inventory on basis of your stock.",
        disableBeacon: true,
      },
      {
        target: ".inventory_subitem_container",
        content:"This is your inventory related graphs.",
        disableBeacon: true,
      }, {
        target: ".top_vendor_section",
        content:"This is the list of your top vendors.",
        disableBeacon: true,
      }
    ],
    "/dashboard/finances/fees-overview":[
      {
        target: ".mues_dashboard",
        content:"Welcome to Finance Section.",
        disableBeacon: true,
        placement: "center"
      },
      {
        target: ".finance_main_container",
        content:"This is your fees related graphs",
        disableBeacon: true,
      },
      {
        target: ".finance_sub_container",
        content:"Here you can see the summary of your fees and student list.",
        disableBeacon: true,
      }
    ],
    "/dashboard/finances/analysis":[
      {
        target: ".finance_item_container",
        content:"This is your transaction related graphs",
        disableBeacon: true,
      },
      {
        target: ".recent_transaction_section",
        content:"This is the list of your recent transactions.",
        disableBeacon: true,
      },
      {
        target: ".finance_information_section",
        content:"Summary of your transactions.",
        disableBeacon: true,
      },
      {
        target: ".student_fees_section",
        content:"Here you can see the summary student list.",
        disableBeacon: true,
      }
    ],
    "/dashboard/finances/add-transaction":[
      {
        target: ".mues_dashboard",
        content:"This is your add-finance section. Here you can add or see your transactions",
        disableBeacon: true,
        placement: "center"
      }
    ],
    "/dashboard/security/camera-feeds":[
      {
        target: ".mues_dashboard",
        content:"This is your Security Section. Here you can see your camera related data.",
        disableBeacon: true,
        placement: "center"
      }
    ],
    "/dashboard/security/outsiders":[
      {
        target: ".mues_dashboard",
        content:"This is your Security Section. Here you can see your camera related data.",
        disableBeacon: true,
        placement: "center"
      },{
        target: ".preschool_wallet_container",
        content:"This is your wallet. Here you can see the amount that has been credited to your school.",
        disableBeacon: true,
        placement: "right"
      },{
        target: ".preschool_wallet_container",
        content:"This is your wallet. Here you can see the amount that has been credited to your school.",
        disableBeacon: true,
        placement: "right",
      }
    ]
  },
};

const virtualTourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    finishTour: (state) => {
      state.runTour = false;
      localStorage.setItem("hasSeenTour", "true");
    },
    addStep: (state, action) => {
      const { path, step } = action.payload;
      if (!state.steps[path]) {
        state.steps[path] = [];
      }
      state.steps[path] = step;
    },
    pauseTour: (state) => {
      state.runTour = false;
    },
    startTour: (state) => {
      state.runTour = true;
    },
  },
});

export const { finishTour, addStep, pauseTour, startTour } =
  virtualTourSlice.actions;
export const getStatus = (state) => state.tour.runTour;
export const getSteps = (state) => state.tour.steps;

export default virtualTourSlice.reducer;
